import { InjectionToken } from '@angular/core';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { LocalDB } from './local-db';
import { StoreAction, XmAction } from './actions';
import {
    cms5GPlanOverviewReducer,
    cmsABTestReducer,
    cmsAccountDataPlanCollectionReducer,
    cmsActivationReducer,
    cmsAdditionalDevicePaymentReducer,
    cmsAddonDetailsReducer,
    cmsAddonErrorsReducer,
    cmsAddonPlansReducer,
    cmsAgentQuickpayReducer,
    cmsBillingAdpReducer,
    cmsBillingCreditReducer,
    cmsBillingExchangeInstructionReducer,
    cmsBillingLandingReducer,
    cmsBillingPaymentReducer,
    cmsBillingStatementReducer,
    cmsBucketSwitchReducer,
    cmsByodExchangeReducer,
    cmsCallFromUSReducer,
    cmsCompatibilityCheckReducer,
    cmsContactBarReducer,
    cmsCoreReducer,
    cmsCountryCodingMappingReducer,
    cmsDataDetailReducer,
    cmsDataSaverReducer,
    cmsDeviceCancelReducer,
    cmsDeviceEsimDownloadReducer,
    cmsDevicePasscodeReducer,
    cmsDeviceReturnReducer,
    cmsDevicesReducer,
    cmsDeviceSuspendReducer,
    cmsDeviceUpgradeReducer,
    cmsErrorsReducer,
    cmsEsimActivationReducer,
    CmsEsimReducer,
    cmsExchangeOrderReducer,
    cmsExtendedPromosReducer,
    cmsHopReducer,
    cmsInternationalCallingReducer,
    cmsInternationalReducer,
    cmsInternationalTravelReducer,
    cmsLevelMoveEligibilityReducer,
    cmsLevelMoveErrorReducer,
    cmsLevelMoveInProgressReducer,
    cmsLevelMovePendingReducer,
    cmsLevelMoveStartReducer,
    cmsLevelMoveSuccessReducer,
    cmsLineDataPlanCollectionReducer,
    CmsLineTransferReducer,
    cmsLoginReducer,
    cmsMyAccountModalsReducer,
    cmsMyAccountReducer,
    cmsnonXfinityCustomerReducer,
    cmsOneTimePaymentReducer,
    cmsOrderDetailReducer,
    cmsPlanSwitchReducer,
    cmsQuickpayBreadcrumbsReducer,
    cmsQuickpayErrorsReducer,
    cmsRetryPaymentReducer,
    cmsReturnOrderReducer,
    cmsSettingsReducer,
    cmsSimSwapReducer,
    cmsStatementListReducer,
    cmsTradeInDeviceReducer,
    cmsTravelRatesReducer,
    cmsUsageDetailReducer,
    cmsUserQuickpayReducer,
    cmsVideoResolutionReducer,
    cmsXmbComingSoonReducer
} from './cms/reducer';
import { loggerReducer } from './logger/reducer';
import { deviceEsimTransferReducer } from './esim/reducer';
import { breezeReducer } from './breeze/reducer';
import { userReducer } from './user/reducer';
import { User } from './user/models';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const reducers: ActionReducerMap<LocalDB, XmAction<any>> = {
    cmsCore: cmsCoreReducer,
    cmsABTest: cmsABTestReducer,
    cmsBillingAdp: cmsBillingAdpReducer,
    cmsBillingLanding: cmsBillingLandingReducer,
    cmsBillingPayment: cmsBillingPaymentReducer,
    cmsBillingStatement: cmsBillingStatementReducer,
    cmsBillingExchangeInstruction: cmsBillingExchangeInstructionReducer,
    cmsUsageDetail: cmsUsageDetailReducer,
    cmsBillingCredit: cmsBillingCreditReducer,
    cmsOrderDetail: cmsOrderDetailReducer,
    cmsDeviceReturn: cmsDeviceReturnReducer,
    cmsDevices: cmsDevicesReducer,
    cmsDeviceUpgrade: cmsDeviceUpgradeReducer,
    cmsDeviceSuspend: cmsDeviceSuspendReducer,
    cmsDeviceCancel: cmsDeviceCancelReducer,
    cmsErrors: cmsErrorsReducer,
    cmsExchangeOrder: cmsExchangeOrderReducer,
    cmsInternational: cmsInternationalReducer,
    cmsUserQuickpay: cmsUserQuickpayReducer,
    cmsAgentQuickpay: cmsAgentQuickpayReducer,
    cmsQuickpayErrors: cmsQuickpayErrorsReducer,
    cmsQuickpayBreadcrumbs: cmsQuickpayBreadcrumbsReducer,
    cmsReturnOrder: cmsReturnOrderReducer,
    cmsActivation: cmsActivationReducer,
    cmsEsimActivation: cmsEsimActivationReducer,
    cmsLogin: cmsLoginReducer,
    cmsHop: cmsHopReducer,
    cmsXmbComingSoon: cmsXmbComingSoonReducer,
    cmsNonXfinityCustomer: cmsnonXfinityCustomerReducer,
    cmsSettings: cmsSettingsReducer,
    cms5GPlanOverview: cms5GPlanOverviewReducer,
    cmsLevelMoveStart: cmsLevelMoveStartReducer,
    cmsLevelMoveEligibility: cmsLevelMoveEligibilityReducer,
    cmsLevelMoveInProgress: cmsLevelMoveInProgressReducer,
    cmsLevelMovePending: cmsLevelMovePendingReducer,
    cmsLevelMoveSuccess: cmsLevelMoveSuccessReducer,
    cmsLevelMoveError: cmsLevelMoveErrorReducer,
    cmsMyAccount: cmsMyAccountReducer,
    cmsMyAccountModals: cmsMyAccountModalsReducer,
    cmsDataDetail: cmsDataDetailReducer,
    cmsAccountDataPlanCollection: cmsAccountDataPlanCollectionReducer,
    cmsLineDataPlanCollection: cmsLineDataPlanCollectionReducer,
    cmsPlanSwitch: cmsPlanSwitchReducer,
    cmsBucketSwitch: cmsBucketSwitchReducer,
    cmsAddonErrors: cmsAddonErrorsReducer,
    cmsAddonPlans: cmsAddonPlansReducer,
    cmsInternationalTravel: cmsInternationalTravelReducer,
    cmsTravelRates: cmsTravelRatesReducer,
    cmsInternationalCalling: cmsInternationalCallingReducer,
    cmsCallFromUS: cmsCallFromUSReducer,
    cmsAddonDetails: cmsAddonDetailsReducer,
    cmsDataSaver: cmsDataSaverReducer,
    cmsContactBar: cmsContactBarReducer,
    cmsOneTimePayment: cmsOneTimePaymentReducer,
    cmsStatementList: cmsStatementListReducer,
    cmsAdditionalDevicePayment: cmsAdditionalDevicePaymentReducer,
    cmsRetryPayment: cmsRetryPaymentReducer,
    cmsExtendedPromos: cmsExtendedPromosReducer,
    cmsSimSwap: cmsSimSwapReducer,
    cmsByodExchange: cmsByodExchangeReducer,
    cmsCountryCodingMapping: cmsCountryCodingMappingReducer,
    cmsLineTransfer: CmsLineTransferReducer,
    cmsEsimDownload: cmsDeviceEsimDownloadReducer,
    cmsOneTimePasscode: cmsDevicePasscodeReducer,
    cmsCompatibilityCheck: cmsCompatibilityCheckReducer,
    cmsTradeInDevice: cmsTradeInDeviceReducer,
    cmsVideoResolution: cmsVideoResolutionReducer,
    user: userReducer,
    logger: loggerReducer,
    cmsEsim: CmsEsimReducer,
    deviceEsimTransfer: deviceEsimTransferReducer,
    breeze: breezeReducer
};

export const REDUCER_TOKEN: InjectionToken<ActionReducerMap<XmAction<any>>> = new InjectionToken<ActionReducerMap<XmAction<any>>>('reducers');

export function clearState(reducer: ActionReducer<LocalDB>): ActionReducer<LocalDB> {
    return (state: LocalDB, action: Action): LocalDB => {
        if (action.type === StoreAction.CLEAR_ON_SUBMIT) {
            Object.keys(state).forEach((key: string) => {
                if (key === 'user') {
                    if (state[key]) {
                        state[key] = new User({ account: state[key].account });
                    }
                } else if (key !== 'orderDetail' && key !== 'byodEligibility' && !key.startsWith('cms')) {
                    state[key] = undefined;
                }
            });
        }

        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<LocalDB>[] = [clearState];
/* eslint-enable @typescript-eslint/no-explicit-any */
